import { Box, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const UserStories = styled(Box)({
	...flexMixin({ align: 'flex-start', direction: 'column', gap: 8 }),
	width: '100%',
});
